/* YUNAA — interactions du site.
   Aucune dépendance. Chaque module s'annule si son balisage est absent,
   donc une page qui n'utilise qu'une partie du kit ne casse rien. */

(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  };

  /* ── Menu plein écran ── */
  function menu() {
    var panneau = $("[data-menu]");
    var ouvrir = $("[data-menu-open]");
    var fermer = $("[data-menu-close]");
    if (!panneau || !ouvrir) return;

    function bascule(ouvert) {
      panneau.classList.toggle("on", ouvert);
      ouvrir.setAttribute("aria-expanded", String(ouvert));
      document.body.style.overflow = ouvert ? "hidden" : "";
      if (ouvert) {
        var premier = panneau.querySelector("a, button");
        if (premier) premier.focus({ preventScroll: true });
      }
    }

    ouvrir.addEventListener("click", function () {
      bascule(!panneau.classList.contains("on"));
    });

    if (fermer) {
      fermer.addEventListener("click", function () {
        bascule(false);
        ouvrir.focus();
      });
    }

    panneau.addEventListener("click", function (e) {
      if (e.target.closest("a")) bascule(false);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panneau.classList.contains("on")) {
        bascule(false);
        ouvrir.focus();
      }
    });
  }

  /* ── Panneaux dépliants de la fiche produit ── */
  function panneaux() {
    $$("[data-panel]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var ouvert = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!ouvert));
      });
    });
  }

  /* ── Galerie plein cadre ──
     Les vues défilent au doigt : c'est le navigateur qui gère le geste
     (scroll-snap). Ici on ne fait que deux choses — amener la bonne vue
     quand on clique une miniature, et suivre le défilement pour marquer
     la miniature active. */
  function galerie() {
    var racine = $("[data-gal]");
    if (!racine) return;

    var piste = $("[data-gal-piste]", racine);
    var minis = $$("[data-gal-go]", racine);
    var vues = $$(".gal__vue", racine);
    if (!piste || !minis.length || !vues.length) return;

    function marquer(i) {
      minis.forEach(function (m, j) {
        m.setAttribute("aria-current", String(j === i));
      });
    }

    minis.forEach(function (m) {
      m.addEventListener("click", function () {
        var i = parseInt(m.getAttribute("data-gal-go"), 10) || 0;
        piste.scrollLeft = piste.clientWidth * i;
        marquer(i);
      });
    });

    /* On lit la position du défilement plutôt que d'écouter chaque pixel :
       moins de calculs, et ça suit aussi bien le doigt que la molette. */
    var attente = false;
    piste.addEventListener("scroll", function () {
      if (attente) return;
      attente = true;
      requestAnimationFrame(function () {
        var i = Math.round(piste.scrollLeft / piste.clientWidth);
        marquer(Math.max(0, Math.min(vues.length - 1, i)));
        attente = false;
      });
    }, { passive: true });

    /* Flèches gauche et droite au clavier */
    piste.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      var i = Math.round(piste.scrollLeft / piste.clientWidth);
      i += e.key === "ArrowRight" ? 1 : -1;
      i = Math.max(0, Math.min(vues.length - 1, i));
      piste.scrollLeft = piste.clientWidth * i;
      marquer(i);
    });
  }

  /* ── Filtres du catalogue ── */
  function filtres() {
    var barre = $(".chips");
    if (!barre) return;

    barre.addEventListener("click", function (e) {
      var chip = e.target.closest(".chip");
      if (!chip) return;

      $$(".chip", barre).forEach(function (c) {
        var actif = c === chip;
        c.classList.toggle("chip--on", actif);
        c.setAttribute("aria-selected", String(actif));
      });
    });
  }

  /* ── Quantité ── */
  function quantite() {
    var bloc = $("[data-qty]");
    if (!bloc) return;
    var valeur = $("[data-qty-val]", bloc);
    var moins = $("[data-qty-moins]", bloc);
    var plus = $("[data-qty-plus]", bloc);
    if (!valeur || !moins || !plus) return;

    function ecrire(n) { valeur.textContent = String(Math.max(1, Math.min(9, n))); }

    moins.addEventListener("click", function () { ecrire(parseInt(valeur.textContent, 10) - 1); });
    plus.addEventListener("click", function () { ecrire(parseInt(valeur.textContent, 10) + 1); });
  }

  /* ── Panier ──
     Démonstration : on incrémente la pastille et on confirme le geste.
     C'est le seul endroit à remplacer pour brancher la boutique. */
  function panier() {
    var compteurs = $$("[data-cart-count]");

    $$("[data-ajouter]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var qte = $("[data-qty-val]");
        var n = qte ? parseInt(qte.textContent, 10) || 1 : 1;

        compteurs.forEach(function (c) {
          c.textContent = String((parseInt(c.textContent, 10) || 0) + n);
        });

        var avant = btn.innerHTML;
        btn.textContent = "AJOUTÉ AU PANIER";
        btn.disabled = true;
        setTimeout(function () {
          btn.innerHTML = avant;
          btn.disabled = false;
        }, 1600);
      });
    });
  }

  function init() {
    menu();
    panneaux();
    galerie();
    filtres();
    quantite();
    panier();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
